import { useCallback } from "react";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
const useSendEventActionTelemetry = () => {
  const sendTelemetry = useSendTelemetry("alerts-and-events");
  return useCallback(
    (actionName, fromBulk, eventDetails = {}) => sendTelemetry(TELEMETRY_EVENT_TYPE.ALERTS_AND_EVENTS.ACTION_RAN, {
      event_details: {
        actionName,
        fromBulk: !!fromBulk,
        ...eventDetails
      }
    }),
    [sendTelemetry]
  );
};
export default useSendEventActionTelemetry;
